var _rect, _rect2, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUploadAvatar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 66,
    viewBox: "0 0 67 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    fill: "#F2F4F7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 5.5,
    y: 5,
    width: 56,
    height: 56,
    rx: 28,
    stroke: "#F9FAFB",
    strokeWidth: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8119_10817)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38.1664 37.6667L33.4997 33.0001M33.4997 33.0001L28.833 37.6667M33.4997 33.0001V43.5001M43.288 40.4551C44.4259 39.8347 45.3248 38.8531 45.8429 37.6651C46.3609 36.4772 46.4686 35.1505 46.1489 33.8945C45.8293 32.6386 45.1004 31.5248 44.0775 30.7291C43.0545 29.9333 41.7957 29.5009 40.4997 29.5001H39.0297C38.6766 28.1342 38.0184 26.8661 37.1046 25.7912C36.1909 24.7163 35.0454 23.8626 33.7542 23.2941C32.463 22.7257 31.0597 22.4573 29.6498 22.5093C28.24 22.5612 26.8603 22.9321 25.6144 23.594C24.3685 24.2559 23.2889 25.1917 22.4568 26.3309C21.6246 27.4701 21.0615 28.7832 20.8099 30.1714C20.5582 31.5595 20.6245 32.9867 21.0038 34.3455C21.3831 35.7044 22.0655 36.9596 22.9997 38.0167",
    stroke: "#475467",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8119_10817"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(19.5 19)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadAvatar);
export default __webpack_public_path__ + "static/media/uploadAvatar.856ac56d34d32a7c90f31c0db927c278.svg";
export { ForwardRef as ReactComponent };